export default __webpack_public_path__ + "static/iStock-1132482720-a75842e734188c5171b9d1bd95856cd7.mp4";